import type { Avatar, UserPayload } from "@/types";

export default class User {
  firstName: string;
  lastName: string;
  isStaff: boolean;
  avatar: Avatar;

  constructor({ first_name: firstName, last_name: lastName, is_staff: isStaff, avatar }: UserPayload) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.isStaff = isStaff;
    this.avatar = avatar;
  }
}
